export const SHARED = Object.freeze({
	DEFAULT_LAYOUT: 'app-layout',
	PUBLIC_LAYOUT: 'app-layout-public',
	EMPTY_LAYOUT: 'app-layout-empty',
	DEFAULT_LANGUAGE: 'en',
	FALLBACK_LANGUAGE: 'en',
	DEFAULT_ALL_VALUE: -1,
	DEFAULT_ALL_VALUE_STR: '',
	DEFAULT_PAGE_NUMBER: 1,
	DEFAULT_PAGE_SIZE: 10,
	USER_IDLE_TIME: process.env.VUE_APP_USER_IDLE_TIME, //3600000=60 Minutes
});

export const DATE = Object.freeze({
	LONG: 'DD-MMM-YYYY HH:mm:ss',
	SHORT: 'DD-MMM-YYYY',
	TIME: 'HH:mm:ss',
	TIME_SHORT: 'HH:mm',
	DATE_TIME_SHORT: 'DD-MMM-YYYY HH:mm',
});

export const SESSION = Object.freeze({
	USER: 'user',
	USER_NAME: 'name',
	USER_TYPE: 'userType',
	JWT_TOKEN: 'token',
	TOKEN_EXPIRY_TIME: 'authTokenExpiryTime',
	REFRESH_TOKEN_EXPIRY_TIME: 'authRefreshTokenExpiryTime',
	PERMISSIONS: 'permissions',
	USER_SEARCH: 'userSearch',
	DEPARTMENT_SEARCH: 'departmentSearch',
	COUNTRY_SEARCH: 'countrySearch',
	OFFICE_TYPE_SEARCH: 'officeTypeSearch',
	COMPANY_SEARCH: 'companySearch',
	COMPANY_TYPE_SEARCH: 'companyTypeSearch',
	GROUP_SEARCH: 'groupSearch',
	STATE_SEARCH: 'stateSearch',
	WORKGROUP_SEARCH: 'workgroupSearch',
	APP_MEETING_ROOM_BOOKING_SEARCH: 'appMeetingRoomBookingSearch',
	ORIENTATION_MODULE_ASSIGNMENT_SEARCH: 'orientationModuleAssignmentSearch',
	ORIENTATION_MODULE_HEADER_SEARCH: 'orientationModuleHeaderSearch',
	PANEL_TYPE_SEARCH: 'panelTypeSearch',
	PANEL_SEARCH: 'panelSearch',
	OFFICE_SEARCH: 'officeSearch',
	PROPERTY_ACTION_SEARCH: 'propertyActionSearch',
	PROPERTY_ASSET_SEARCH: 'propertyAssetSearch',
	PROPERTY_ASSET_TENANT_SEARCH: 'propertyAssetTenantSearch',
	PROPERTY_TENANTED_SEARCH: 'propertyTenantedSearch',
	PROPERTY_AREA_UNIT_SEARCH: 'propertyAreaUnitSearch',
	PROPERTY_CATEGORY_SEARCH: 'propertyCategorySearch',
	PROPERTY_TENURE_SEARCH: 'propertyTenureSearch',
	PROPERTY_TYPE_SEARCH: 'propertyTypeSearch',
	PROPERTY_STATUS_SEARCH: 'propertyStatusSearch',
	POSITION_SEARCH: 'positionSearch',
	CANDIDATE_STATUS_SEARCH: 'candidateStatusSearch',
	CANDIDATE_JOB_SEARCH: 'candidateJobSearch',
	CANDIDATE_SEARCH: 'candidateSearch',
	ARTICLE_SEARCH: 'articleSearch',
	NOTIFICATION_SEARCH: 'notificationSearch',
	DOCUMENT_SEARCH: 'documentSearch',
	LOCATION_SEARCH: 'locationSearch',
	ERROR_LOG_SEARCH: 'errorLogSearch',
	REQUEST_LOG_SEARCH: 'requestLogSearch',
	ACTIVITY_LOG_SEARCH: 'activityLogSearch',
	COMMUNICATION_LOG_SEARCH: 'communicationLogSearch',
	SERVEDECK_LOG_SEARCH: 'servedeckLogSearch',
});

export const APIHELPER = Object.freeze({
	NETWORK_ERROR: "Network Error", 
	UNKNOWN_ERROR: "Unknown Error", 
	INVALID_USER: "Invalid User", 
	OBJECT: "object", 
	OBJECT_INVALID: " is Invalid", 
	NETWORK_ERROR_CODE: "0.96", 
	UNKNOWN_ERROR_CODE: "0.99", 
});

export const API = Object.freeze({
	BASE_URL_API: process.env.VUE_APP_API_BASE_URL,
	BASE_URL_APP: process.env.VUE_APP_API_BASE_URL_IHEXTAR,
	S3_IMAGE_URL: process.env.VUE_APP_S3_URL,
}); 

export const IHEXTAR_AUTH = Object.freeze({
	KEY_STRING: process.env.VUE_APP_KEY_STRING,
	KEY_IV: process.env.VUE_APP_KEY_IV,
});
